angular.module('edxResources')
.component('edxDownloadableResource', {
  bindings: {
    image: '<',
    links: '<',
    layout: '<?',
    analyticsCategory: '<',
    moduleName: '<',
    name: '<',
    description: '<?',
    isNew: '<'
  },
  templateUrl: '/resources/components/edx-resources/edx-downloadable-resource.component.html',
  controllerAs: 'vm',
  controller: function() {
    var vm = this;

    vm.linkLines = [];

    vm.getAnalyticsEvent = function (linkType) {
      switch (linkType) {
        case 'zip':
          return 'Download Zip';
        case 'pdf':
          return 'PDF Clicked';
        case 'ppt':
          return 'PPT Clicked';
        default:
          return 'Click';
      }
    };

    vm.$onInit = function() {
      var lineSize = vm.layout === 'vertical' ? 1 : 2;

      vm.linkLines = _.chunk(vm.links, lineSize);
    };
  }
});
